import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderingCoreService } from './ordering-core.service';
import { OrderingSelectorComponent } from './ordering-selector/ordering-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [OrderingSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [OrderingCoreService],
  exports: [OrderingSelectorComponent],
})
export class OrderingCoreModule {}
